import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {SessionStorageAdsRepository} from '../Repositories/SessionStorageAdsRepository.js'

export class GetComparatorAdsService extends Service {
  #repository

  #handleError(error) {
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create() {
    return new GetComparatorAdsService({repository: SessionStorageAdsRepository.create()})
  }

  @AsyncInlineError()
  async execute() {
    try {
      const [error, response] = await this.#repository.getComparatorAds()
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}
